import { payRecordApi } from "./payRecordApi";

export const payRecordSetData = async (
  lang,
  setMessageResponse,
  cookies,
  credintial,
  setSuccessMessage,
  setBtnLoader,
  outgoingId
) => {
  const response = await payRecordApi(credintial, lang, cookies, outgoingId);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      message: response.res.data.message,
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
